var React = require('react');

function CheckboxCheckedCheckmark (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Rectangle","fill":"#fff","stroke":"#bdc1c6","strokeMiterlimit":"10","strokeWidth":"1","key":0},[React.createElement("rect",{"width":"15","height":"15","stroke":"none","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"14","height":"14","fill":"none","key":1})]),React.createElement("path",{"id":"Path","d":"M7.726.281,3,6.583l-1.723-2.3A.627.627,0,0,0,.22,4.3,1.251,1.251,0,0,0,.211,5.7l2.255,3a.628.628,0,0,0,1.063,0L8.789,1.7A1.251,1.251,0,0,0,8.78.293.627.627,0,0,0,7.726.281Z","transform":"translate(3 3)","fill":"#244c5a","key":1})]);
}

CheckboxCheckedCheckmark.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = CheckboxCheckedCheckmark;

CheckboxCheckedCheckmark.default = CheckboxCheckedCheckmark;
